export const setBillingActionEventAsHandledByCustomer = `mutation SetBillingActionEventAsHandledByCustomer($eventType: String!) { 
    setBillingActionEventAsHandledByCustomer(eventType: $eventType) {
        eventType
    }
}`
